var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _c('landing-create', {
    attrs: {
      "content": _vm.content
    }
  }), _c('v-card', [_c('v-row', [_c('v-col', {
    staticClass: "role-section",
    attrs: {
      "cols": "12",
      "md": "12",
      "xl": "12"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "rd"
    }
  }, [_vm.roleModel._id ? _c('role-form', {
    attrs: {
      "role-model": _vm.roleModel
    },
    on: {
      "onSubmit": _vm.onSubmit
    }
  }) : _vm._e()], 1)])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }